// extracted by mini-css-extract-plugin
export var statItem = "_kl-1";
export var statsRow = "_kl-0";